import React, { useContext } from 'react';
import './PriceDifferenceInfo.css';
import { useNavigate } from 'react-router-dom';
import GlowingAdvanceIcon from '../../assets/GlowingAdvanceIcon.jsx';
import PropTypes from 'prop-types';
import useNormalizedSubscriptionStatus from '../../services/utils/subscriptionUtils.js';
import ROUTES from '../../services/Constants/GlobalRoutes.jsx';
import { SubscriptionDetailsContext } from '../../services/context/SubscriptionDetailsContext.js';
import { allowedStatuses } from '../../services/Constants/config.js';
import { MoneyFormatterContext } from '../../services/context/MoneyFormatterContext.js';

/**
 * @param {{ amount: number, isClubMember?: boolean }} root0 - component props
 * @param {number} root0.amount - savings amount to display (from clubPriceDifference in API response)
 * @param {boolean} [root0.isClubMember] - whether the user is a VodaPay Club member
 * @returns {JSX.Element|null} PriceDifferenceInfo component
 */
export default function PriceDifferenceInfo({ amount = 0, isClubMember: isClubMemberProp }) {
  const navigateTo = useNavigate();
  const subscriptionDetails = useContext(SubscriptionDetailsContext);
  const subscriptionStatus = useNormalizedSubscriptionStatus();
  const isClubMember = isClubMemberProp ?? (subscriptionStatus === 'active');
  const MoneyFormatter = useContext(MoneyFormatterContext);
  const diffAmount = amount ?? 0;
  const joinClubButtonText = subscriptionDetails?.plans?.length === 1 ? `Join for R${subscriptionDetails?.plans[0]?.price}` : 'Join the Club';

  if (!diffAmount) return null;

  return (
    <div className='price-difference-info-container'>
      <div className='price-difference-info-left-content'>
        {
          isClubMember ? (
            <>
              You got <span className='price-difference-info-amount'>{ MoneyFormatter.format(MoneyFormatter.get(diffAmount)) }</span> extra for being a VodaPay Club member
            </>
          ) : (
            <>
              You lost <span className='price-difference-info-amount'>{ MoneyFormatter.format(MoneyFormatter.get(diffAmount)) }</span> extra – Join the club for more value
            </>
          )
        }
      </div>
      <div
        className={ isClubMember ? 'price-difference-info-right-icon' : 'price-difference-info-right-button' }
        onClick={
          () => {
            if (!isClubMember) {
              const subscriptionApiFailed = !subscriptionDetails?.status || !allowedStatuses.includes(subscriptionDetails.status);
              if (subscriptionApiFailed) navigateTo(ROUTES.HOME, { replace: false });
              else navigateTo(ROUTES.VODAPAY_CLUB, { replace: false });
            }
          }
        }
      >
        {isClubMember ? <GlowingAdvanceIcon /> : joinClubButtonText }
      </div>
    </div>
  );
}

PriceDifferenceInfo.propTypes = {
  amount: PropTypes.number,
  isClubMember: PropTypes.bool,
};
